import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M88 40V24C88 19.56 84.4 16 80 16H16C11.6 16 8.04 19.56 8.04 24V40C12.44 40 16 43.6 16 48C16 52.4 12.44 56 8 56V72C8 76.4 11.6 80 16 80H80C84.4 80 88 76.4 88 72V56C83.6 56 80 52.4 80 48C80 43.6 83.6 40 88 40ZM52 70H44V62H52V70ZM52 52H44V44H52V52ZM52 34H44V26H52V34Z",
  fill: "inherit"
}), 'CupomPromotion', {
  viewBox: '0 0 96 96'
});